/*
 * @Author: luoguo
 * @Date: 2024-01-23 10:39:05
 * @LastEditTime: 2024-09-20 10:01:45
 * @LastEditor: zhangkun
 * @Description:
 */
/*
Author: Liubo
Date: 2018-09-05
Desc: 框架配置文件
*/
import urls from "@/api/urls";
const conf = {
    name: "JTUP framework",
    sysname: "--",
    systemtype: "2", // 0:柜台, 2:网上交易, 3:传真, 4:手机, 5: 微信
    api: {
        // axios AJAX 请求时的路径前缀
        baseUrl: process.env.NODE_ENV === "production" ? "/agate/api/v1" : "/api/v1",
        v5BaseUrl: process.env.NODE_ENV === "production" ? "/" : "/h5api",
        // 银行页面链接地址配置
        bankUrl: "/agate/jfit"
    },
    secretId: "000001",
    deviceType: "wechatapplet",
    session_mode: "1", // 1:agate模式，通过token和key控制会话; 2:传统JROS模式, 前端不做特殊处理，由浏览器session 机制和服务端来控制会话
    // encKey: "testkey", // 加密因子。仅用于session_mode 为2的情况。如果session_mode 为1，会取服务端返回的会话信息中的key作为加密因子
    encKey: "01234567890abcde", // 加密因子。仅用于session_mode 为2的情况。如果session_mode 为1，会取服务端返回的会话信息中的key作为加密因子
    encIV: "0102020303040506", // 加密向量
    projectType: "1", // 项目类型0直销，1代销
    onlyPrivateFund: false, // 是否仅展示高端理财
    hideFunc: true, // 控制是否隐藏/屏蔽功能  true-不隐藏  false-隐藏（屏蔽开户/交易类操作）
    isPhoneLog: false, // 控制是否验证码登录
    isKen: false, // 控制是否要脱敏
    const: {
        TTY_CHANLEID: "6000", // 天天盈网点号
        CARD_DATE_MAX: "99991231", // 证件号有效期最大值
        BIRTH_DATE: "19000101", // 出生日期最小值
        PAGE_SIZE: "10", // 分页数
        ZX_CENTER: "1000" // 直销中心渠道号
    },
    defaultEmailSuffix: "@qq.com,@163.com,@gmail.com,@sohu.com", // ump没有配置，取默认邮箱后缀
    cache: [
        // {
        //     code: "_session",
        //     api: "/common/session",
        //     method: "GET",
        //     load: true,
        // },
        {
            code: "_dict",
            api: urls.dict,
            method: "POST",
            load: true
        },
        {
            code: "_params",
            api: urls.companyInfo,
            method: "POST",
            load: true
        },
        {
            code: "_user",
            api: urls.acctInfo,
            method: "POST",
            load: true
        },
        {
            code: "_moduleParam",
            api: urls.qryModuleParamService,
            method: "POST",
            load: true
        }
        // {
        //     code: "_advertise",
        //     api: "/common/advertinfo",
        //     method: "GET",
        //     load: true,
        // },
        // {
        //     code: "_notice",
        //     api: "/common/warmnotice",
        //     method: "GET",
        //     load: true,
        // },
        // {
        //     code: "_user",
        //     api: "/acct/cust/profile",
        //     method: "GET",
        // },
    ],
    fundTypes: [
        { val: "hot", text: "热销基金" },
        { val: "", text: "全部" },
        { val: "1", text: "股票型" },
        { val: "3", text: "混合型" },
        { val: "2", text: "指数型" },
        // { val: "6", text: "QDII" },
        { val: "7", text: "FOF" },
        // { val: "13", text: "商品期货ETF" },
        { val: "4", text: "债券型" },
        { val: "5", text: "货币型" }
        // ,{ val: "z", text: "REITS" }
        // ,{ val: "zghr", text: "中港互认" }
    ],
    privateFundTypes: [{ val: "999", text: "专户产品" }],
    showSpecial: false // 控制是否展示个性化的功能 true-展示  false-隐藏
};
export default conf;
